// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fEPc","option":"styles_option__21xzs","active":"styles_active__2NzxV"};